<template>
    <sarala-table :model="model" :query="query">
        <template #actionHandler>
            <ResellerUserActions ref="actionHandler" />
        </template>
    </sarala-table>
</template>

<script>
import Model from '@/models/ResellerUser'
import ResellerUserActions from '@/components/actions/resellerUser/ResellerUserActions'
import SaralaTable from '@/shared/components/SaralaTable'

export default {
    components: {
        ResellerUserActions,
        SaralaTable,
    },

    props: {
        reseller_id: {
            required: true,
        },
    },

    computed: {
        model() {
            return new Model()
        },
    },

    methods: {
        query(model) {
            return model.where('reseller_id', this.reseller_id)
        },
    },
}
</script>

<style></style>
